import getNested from 'lodash-es/get';
import Vue from 'vue';
import Vuex from 'vuex';
import sortBy from 'lodash-es/sortBy';

Vue.use(Vuex);

export default {
  namespaced: true,

  state: () => {
    return {};
  },

  actions: {
    async getAnchoragePorts({dispatch}) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          apiUrl: '/congestion/port/list',
          data: { }
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      let items = response.data.ports.map((item) => {
        return {
          value: item.portId,
          text: item.portName,
          countryCode: item.countryCode,
          regionName: item.regionName,
        }
      });
      return sortBy(items, ['text']);
    },

    async getAnchorageRegions({dispatch}) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          apiUrl: '/congestion/region/list',
          data: { }
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      let items = response.data.regions.map((item) => {
        return {
          value: item.regionId,
          text: item.regionName
        }
      });
      return sortBy(items, ['text']);
    },

    async getAnchorageRegionsWithPolygons({dispatch}) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          apiUrl: '/tradeflows/regionswithpolygon',
          data: {direction:"export"}
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      let items = response.data.regions.map((item) => {
        return {
          value: item.regionId,
          text: item.regionName,
          geoJSON: JSON.parse(item.geojson),
        }
      });
      return sortBy(items, ['text']);
    },

    async getAnchorageCountries({dispatch}) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          apiUrl: '/congestion/country/list',
          data: { }
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      let items = response.data.countries.map((item) => {
        return {
          value: item.countryCode,
          text: item.country
        }
      });
      return sortBy(items, ['text']);
    },

    async getPortCongestionStats({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/congestion/port',
          data: parameters
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      return response;
    },

    async getCountryCongestionStats({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/congestion/country',
          data: parameters
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      return response;
    },

    async getRegionCongestionStats({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/congestion/region',
          data: parameters
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response;
    },

    async getCongestionSummary({dispatch}, parameters) {
      // expected parameters:
      // {
      //   "location_type": "region",  // "region", "country", "port"
      //   "metric": "vessel_count",  // "vessel_count", "vessel_dwt"
      // }

      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/congestion/summary',
          data: parameters
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response;
    },

    async getFullCongestionData({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/congestion/new',
          data: parameters
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data', {});
    },

    async getCongestionVesselsExportData({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/congestion/live',
          data: parameters
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      return response;
    },

    async getCongestionTimeseriesExportData({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/congestion/timeseries',
          data: parameters
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      return response;
    },

    async apiRequest(store, parameters) {
      // here you can override common API request parameters for this api module
      // for example:
      // parameters: {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL},
      return store.dispatch(
        'api/apiRequest',
        {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL_V2},
        { root: true },
      );
    },
  },
}
